/** Console v0.5: words that must stay word for word (design brief v0.5 s.6), shared by Home and the organisation
 * workspace. Tested for exact text (web/console/test/v05-format.test.ts). */

import type { Service } from "./items-api.js";

export const FINANCING_LINE = "We work with our lending partners to find a suitable option for your financing needs.";
export const FINANCING_SMALL_PRINT =
  "Preekie and CPAI Australia don't provide financial product advice and don't arrange investments. Lending decisions are made by the lender. If we receive a referral fee, we'll tell you before you proceed.";
export const TAX_NOTE = "Lodged through our registered tax agent partner.";
export const ASSURANCE_NOTE = "Internal reviews. Certification is issued by an accredited certification body, not by Preekie.";
export const AI_PROMISE = "Prepared by AI. Approved by you. Nothing is lodged or sent until a person with approval rights says so.";

/** The four service cards (Home mock-up): name, its line under the name, and its fixed note. */
export const SERVICES: ReadonlyArray<{ service: Service; name: string; tag: string; note: string | null; smallPrint: string | null }> = [
  { service: "accounting", name: "Accounting", tag: "Bookkeeping and month-end", note: null, smallPrint: null },
  { service: "tax", name: "Tax", tag: "BAS and income tax", note: TAX_NOTE, smallPrint: null },
  { service: "assurance", name: "Assurance", tag: "ISO 27001 readiness", note: ASSURANCE_NOTE, smallPrint: null },
  { service: "financing", name: "Financing", tag: "Via lending partners", note: FINANCING_LINE, smallPrint: FINANCING_SMALL_PRINT },
];
